export function phoneValidator(value: string) {
  const stripped = value ? value.replace(/\D+/g, '') : '';

  if (/^\d{9,100}$/.test(stripped)) {
    return true;
  }

  return false;
}
